'use strict';

/**
 * View for rendering the list of unused albums
 *
 * @category   View
 * @module     collection.album
 * @copyright  Copyright (c) 2014, COLIDO (http://www.colido.net)
 * @author     Stefan Rueschenberg <sr@humans.am>
 * @author     Jonas Girnatis <dermusterknabe@gmail.com>
 */

var ColidoCompositeView = require('base/Colido.CompositeView');
var ListItemUnusedView = require('./list-item-unused');

var template = require('../../templates/partials/list-unused.hbs');

var ListUnusedView = ColidoCompositeView.extend({
    template: template,

    context: 'default',

    childView: ListItemUnusedView,

    childViewContainer: '#list-unused',

    collectionEvents: {
        'add remove sync filter-complete': 'render',
    },
});

module.exports = ListUnusedView;